export const baseTransition = {
  duration: 0.9,
  ease: [0.22, 1, 0.36, 1],
};

export const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: baseTransition,
  },
};

export const fadeInDown = {
  hidden: { opacity: 0, y: -40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: baseTransition,
  },
};

export const fadeInLeft = {
  hidden: { opacity: 0, x: 40 },
  visible: {
    opacity: 1,
    x: 0,
    transition: baseTransition,
  },
};

export const fadeInRight = {
  hidden: { opacity: 0, x: -40 },
  visible: {
    opacity: 1,
    x: 0,
    transition: baseTransition,
  },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { ...baseTransition, duration: 0.7 },
  },
};

export const blurFade = {
  hidden: { opacity: 0, filter: 'blur(10px)', y: 24 },
  visible: {
    opacity: 1,
    filter: 'blur(0px)',
    y: 0,
    transition: { ...baseTransition, duration: 1 },
  },
};

export const createStaggerContainer = ({ staggerChildren = 0.2, delayChildren = 0 } = {}) => ({
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren,
      delayChildren,
    },
  },
});

export const getScrollAnimationProps = (shouldReduceMotion, { amount = 0.3 } = {}) =>
  shouldReduceMotion
    ? {}
    : {
        initial: 'hidden',
        whileInView: 'visible',
        viewport: { once: true, amount },
      };

export const getHeroAnimationProps = (shouldReduceMotion) =>
  shouldReduceMotion
    ? {}
    : {
        initial: 'hidden',
        animate: 'visible',
      };

export const createFloatingAnimation = ({ offset = 12, duration = 16, delay = 0 } = {}) => ({
  y: [0, -offset, 0, offset, 0],
  x: [0, offset / 3, -offset / 2, offset / 4, 0],
  transition: {
    duration,
    ease: 'easeInOut',
    repeat: Infinity,
    repeatType: 'mirror',
    delay,
  },
});
